import type { ClientConfig } from "@libs/aigon-api/clientConfig.js";
import { fetchClientConfig } from "../api/fetchClientConfig.js";
import { CognitoClient } from "../utils/aws/cognito/CognitoClient.svelte.js";

function createCognitoClient(config: ClientConfig): CognitoClient {
	return new CognitoClient(
		config.awsRegion,
		config.cognitoClientId,
		config.cognitoIdentityPoolId,
		config.cognitoUserPoolId,
		true,
		config.cognitoDomain,
		config.cognitoEndpoint,
	);
}

export let cognitoClient: CognitoClient;

/**
 * The app must authenticate against whichever Cognito environment the API it talks to is
 * configured for (which can differ from the app's own deployment, e.g. a local app pointed at a
 * sandbox-configured local API), so Cognito config always comes from the API instead of the app's
 * own build-time env.
 */
export async function initCognitoClient(): Promise<void> {
	cognitoClient = createCognitoClient(await fetchClientConfig());
}
